<div  [hidden]="!allowCustomerNotes && !instructionChoice"
      class="padded-right-20-md padded-right-20-sm padded-right-sm-down padded-left-20" [ngClass]="{'padded-right-20': inItemEditorModal}">
  <button class="btn btn-link btn-undecorated btn-choice text-left instructions-btn" (click)="toggleExpand()"
          [attr.aria-label]="(instructionChoice?.name || ('component.item_editor.item_instructions.special_instructions' | translate))" [attr.aria-expanded]="expanded">
    <fa-icon class="icon-smaller" [icon]="expanded ? faMinus : faPlus"></fa-icon>
    {{instructionChoice?.name || ('component.item_editor.item_instructions.special_instructions' | translate)}}
  </button>
  <div *ngIf="expanded"
       [ngClass]="{'panel-expanded' : expanded}"
       [@expanded]="expanded"
       (@expanded.done)="expandedAnimationEnd()">
    <div class="form-group instructions-panel no-margin padded-bottom-15">
      <fts-choice
        *ngIf="instructionChoice"
        [item]="item"
        [choice]='instructionChoice'
        [itemSize]="item?.size"
        [isInModal]='isInModal'
        [isDependingIngredientOrdered]="true"
        [orderedChoice]='(item | orderedChoice : instructionChoice?.name)'
        [ignoreIngredientGroups]="true"
        [inItemEditorModal]="inItemEditorModal"
        (toggleIngredients)='toggleInstructions($event)'
        (toggleQualifier)='onToggleQualifier($event)'
        (chooseHalf)='onChooseHalf($event)'
      ></fts-choice>

      <ng-container *ngIf='allowCustomerNotes'>
        <label for="instructions" class="col-form-label instructions-label">{{('component.item_editor.item_instructions.notes' | translate)}}:</label>
        <textarea
          ftsAuditableTextControl auditName="Instructions for item '{{orderableItem?.name}}'"
          #instructionsTextArea
          name="instructions"
          id="instructions"
          [maxlength]="maxSpecialInstructionsLength"
          class="form-control vert-resize primary-text-color primary-bg-color"
          [(ngModel)]='instructions'
          (keyup)='setInstructions(instructionsTextArea.value)'
        ></textarea>
        <span *ngIf="customerInstructionsDisclaimer">
          <small>{{customerInstructionsDisclaimer}}</small>
        </span>
      </ng-container>
    </div>
  </div>
</div>
